import React from 'react'
import styled from 'styled-components'
import ParseContent from 'components/shared/ParseContent'

const StyledTextWithTitle = styled.section`
  position: relative;
  z-index: 1;
  padding-top: 30px;
  padding-bottom: 30px;

  @media screen and (max-width: 991px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`

const StyledContainer = styled.div`
  height: 100%;

  @media screen and (max-width: 991px) {
    height: unset;
    position: relative;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 30px;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    gap: 10px;
  }
`

const TitleBlock = styled.div`
  flex-shrink: 0;

  @media screen and (min-width: 992px) {
    width: 50%;
  }

  & h2 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.l};
    }
  }
`

const ContentBlock = styled.div`
  @media screen and (min-width: 992px) {
    width: 50%;
  }
`

const TextWithTitle = ({ className = '', content, id = 'text-with-title' }) => {
  if (!content) return null
  return (
    <StyledTextWithTitle id={id} className={`${className}`}>
      <StyledContainer className="container">
        <Wrapper>
          <TitleBlock>
            <h2>{content?.title}</h2>
          </TitleBlock>
          <ContentBlock>
            <ParseContent content={content?.description} compactLineHeight />
          </ContentBlock>
        </Wrapper>
      </StyledContainer>
    </StyledTextWithTitle>
  )
}

export default TextWithTitle
